import { Director, File, LegacyDocument } from '@commenda/prisma';
import { IAddress } from '@commenda/types';
import { BaseFileType } from '@commenda/types/src/file/types';
import {
  CorporationHasDirectorAdditionalInformation,
  DirectorPersonalDetails,
  TCorporationHasDirectorIncorporationInfo,
} from '@commenda/types/src/random';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export type DirectorsByCorporationType = Director & {
  directorDocuments: (LegacyDocument & {
    files: File[];
  })[];
  directorCorporationDocuments: (LegacyDocument & {
    files: File[];
  })[];
  additionalDirectorInformation: CorporationHasDirectorAdditionalInformation;
  incorporationInfo?: TCorporationHasDirectorIncorporationInfo | null;
  governmentId: BaseFileType;
  mailingAddress: IAddress;
  operatingAddress: IAddress;
  decryptedSSN?: string;
  directorFiles?: File[];
  panCard?: File | null;
  aadharCard?: File | null;
  personalDetails?: DirectorPersonalDetails;
};

export function useDirectorsByCorporation(
  corporationId: number | string,
  token?: string,
  filter?: { shouldIncludeSSN?: boolean }
) {
  const query = new URLSearchParams();

  if (filter?.shouldIncludeSSN) {
    query.append('shouldIncludeSSN', filter.shouldIncludeSSN.toString());
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: DirectorsByCorporationType[];
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `director/byCorporation/${corporationId}?${query}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data,
    error,
    mutate,
  };
}
